<template>
  <Content class="content">
    <section v-if="$route.path == '/index'" class="index-box">
      <div>
        <img style="margin-top:150px" :src="defaultBg" alt="">
        <div style="font-size:25px;line-height:35px;font-weight:bold;text-align:center;">欢迎使用</div>
        <div style="font-size:25px;line-height:35px;font-weight:bold;text-align:center;">{{ projectName }}管理系统</div>
      </div>
    </section>
    <RightColumnTabs></RightColumnTabs>
    <!-- <Breadcrumb v-show="showBreadcrumb"></Breadcrumb> -->
    <!-- :include="cacheRoute" -->

    <!-- <div ref="keepAliveContainer" >
      <keep-alive>
        <router-view :key="$route.name" v-if="ishasCache"></router-view>
        v-if="ifRouterAlive"

      </keep-alive>
    </div> -->

    <keep-alive :include="cacheRoute" :max="20">
      <section v-if="noFunctionRouterListName.includes($route.name)" class="index-box">
        <div>
          <div style="font-size:25px;line-height:35px;font-weight:bold;text-align:center;">功能暂不可用</div>
        </div>
      </section>
      <router-view v-else></router-view>
    </keep-alive>
  </Content>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import RightColumnTabs from '@c/RightColumnTabs';
export default {
  name: 'LayoutContent',
  components: {
    RightColumnTabs
  },
  data() {
    return {
      ishasCache: false,
      defaultBg: require('@/assets/img/data_base.png')

    };
  },
  computed: {
    ...mapState(['cacheRoute', 'keepAliveComponentInstance', 'ifRouterAlive', 'noFunctionRouterListName', 'projectName']),

    ...mapGetters(['browsingHistoryList']),

    cacheRouteArray() {
      return Object.keys(this.browsingHistoryList);
    },
    // 少于4层路由，也就是 列表页除外，显示breadcrum的条件
    isShowBreadcrumb() {
      return this.$route.path != '/index' && this.$route.path.split('/').filter(item => { return item != ''; }).length < 4;
    }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        // this.getKeepAliveContainer()
        this.ishasCache = this.ishasCacheFun();
      },
      immediate: true
    }
  },
  created() {
    console.log(this.$route);
  },
  mounted() {
    // this.getKeepAliveContainer()
  },
  methods: {
    ishasCacheFun() {
      const result = false;
      // if (this.cacheRouteArray.includes(this.$route.name)) {
      const query = this.browsingHistoryList[this.$route.name]['query']; const params = this.browsingHistoryList[this.$route.name]['params'];
      const queryKeys = Object.keys(query); const paramsKeys = Object.keys(params);
      if (this.isShowBreadcrumb) {
        // if (queryKeys.length == 0 && paramsKeys.length == 0 && this.isShowBreadcrumb) {
        return true;
      }
      // }
      return result;
    },
    // 获取keep-alive的控件实例
    getKeepAliveContainer() {
      this.$nextTick(() => {
        if (this.keepAliveComponentInstance && this.keepAliveComponentInstance['cache']) {
          return null;
        }
        if (this.$refs.keepAliveContainer) {
          this.$store.commit('SET_KACI', this.$refs.keepAliveContainer.childNodes[0].__vue__);
        }
      });
    }

  }
};
</script>

<style lang="scss" scoped>
.content {
  min-width: 1180px;
  background-color: #eef0f3;
  max-height: calc(100vh - 110px);
  overflow-y: auto;
  .index-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      h1 {
        text-align: center;
        font-size: 40px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
